import { render, staticRenderFns } from "./singlepage-city.vue?vue&type=template&id=027d06fb&scoped=true&"
import script from "./singlepage-city.vue?vue&type=script&lang=js&"
export * from "./singlepage-city.vue?vue&type=script&lang=js&"
import style0 from "./singlepage-city.vue?vue&type=style&index=0&id=027d06fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027d06fb",
  null
  
)

export default component.exports